export const TILE = 1;
export const GRAVITY = -38;
export const PLAYER_WALK_SPEED = 5.2;
export const PLAYER_RUN_SPEED = 8.4;
export const PLAYER_ACCEL = 34;
export const PLAYER_FRICTION = 30;
export const JUMP_VELOCITY = 20; // apex ~5.26 tiles, clears 4-tile pipes with margin
export const JUMP_CUT_MULT = 0.45;
export const MAX_FALL = -26;
export const ENEMY_SPEED = 1.8;
export const SHELL_KICK_SPEED = 10;
export const MUSHROOM_SPEED = 2.4;
export const START_TIME = 400;
export const LEVEL_WIDTH = 212;

export enum TileType {
  Empty = 0,
  Ground,
  Brick,
  Question,
  QuestionUsed,
  Pipe,
  Block, // stair solid
  Pole
}

export type TilePayload =
  | { kind: "coin" }
  | { kind: "mushroom" };

export interface TileData {
  type: TileType;
  payload?: TilePayload;
  broken: boolean;
  bump: number; // bump animation timer
  flower?: boolean; // pipe with flower on top
}

export type PowerState = "small" | "big" | "fire";

export interface PlayerState {
  x: number;
  y: number;
  vx: number;
  vy: number;
  w: number;
  h: number;
  onGround: boolean;
  facing: 1 | -1;
  power: PowerState;
  crouching: boolean;
  invulnTimer: number;
  alive: boolean;
  deathTimer: number;
  walkPhase: number;
}

export type EnemyKind = "goomba" | "koopa" | "paratroopa" | "shell";

export interface EnemyState {
  kind: EnemyKind;
  x: number;
  y: number;
  vx: number;
  vy: number;
  w: number;
  h: number;
  active: boolean;
  dead: boolean;
  squishTimer: number;
  facing: 1 | -1;
  walkPhase: number;
  onGround: boolean;
  flapTimer?: number; // for paratroopa wing flap cycle
  wasStomped?: number; // frame counter for stomp bounce
}

export interface PowerupState {
  x: number;
  y: number;
  vx: number;
  vy: number;
  w: number;
  h: number;
  exiting: boolean;
  dead: boolean;
}

export interface CoinPop {
  x: number;
  y: number;
  vy: number;
  life: number;
}

export interface FloatScore {
  x: number;
  y: number;
  text: string;
  life: number;
}

export interface InputState {
  left: boolean;
  right: boolean;
  run: boolean;
  jump: boolean;
  jumpPressed: boolean;
  down: boolean;
}

export type GamePhase = "playing" | "dying" | "won" | "gameover";

export interface GameStats {
  score: number;
  coins: number;
  lives: number;
  time: number;
}

export interface EnterablePipe {
  px: number;
  exitX: number;
  exitY: number;
}
